import { Route, Routes } from 'react-router';

import App from '@/dmdrive/core/pages/App/App';
import { PAGE_AUTH } from '@/dmdrive/user/constants/pages';
import Auth from '@/dmdrive/user/pages/Auth/Auth';

function Root() {
  return (
    <Routes>
      <Route path={PAGE_AUTH} element={<Auth />} />

      <Route path="*" element={<App />} />
    </Routes>
  );
}

export default Root;
